import { ClipType } from '@air/api/types';

import { QueryParamNames, type QueryType } from '~/constants/search';

export const IMAGE_COMPARISON_CLIP_TYPES = new Set<ClipType>([ClipType.animated, ClipType.livePhoto, ClipType.photo]);

export const PLAYBACK_COMPARISON_CLIP_TYPES = new Set<ClipType>([ClipType.audio, ClipType.video]);

/** Opens comparison without carrying panel-opening state into the two-up viewer. */
export const getEnterAssetComparisonQuery = (comparisonClipId: string): QueryType => ({
  [QueryParamNames.amTab]: null,
  [QueryParamNames.comparisonClipId]: comparisonClipId,
  [QueryParamNames.versions]: null,
});

export const COMPARISON_MODES = ['sbs', 'slider', 'diff'] as const;

export type ComparisonMode = (typeof COMPARISON_MODES)[number];

export const DEFAULT_COMPARISON_MODE: ComparisonMode = 'sbs';

export const COMPARISON_ACTIVE_PANELS = ['left', 'right'] as const;

export type ComparisonActivePanel = (typeof COMPARISON_ACTIVE_PANELS)[number];

export const COMPARISON_ACTIVE_PANEL_URL_VALUES: Record<ComparisonActivePanel, string> = {
  left: '0',
  right: '1',
};

export const DEFAULT_COMPARISON_ACTIVE_PANEL: ComparisonActivePanel = 'left';

export const DEFAULT_COMPARISON_LINKED = true;

export const MIN_COMPARISON_SLIDER_POSITION = 0;
export const MAX_COMPARISON_SLIDER_POSITION = 100;
export const DEFAULT_COMPARISON_SLIDER_POSITION = 50;

export type PrivateAssetComparisonURLState = {
  activePanel: ComparisonActivePanel;
  comparisonClipId: string | undefined;
  isLinked: boolean;
  mode: ComparisonMode;
  sliderPosition: number;
};

export type PrivateAssetComparisonQueryPatch = Partial<Record<QueryParamNames, string>>;

export const COMPARISON_QUERY_PARAM_NAMES = [
  QueryParamNames.comparisonActivePanel,
  QueryParamNames.comparisonClipId,
  QueryParamNames.comparisonLinked,
  QueryParamNames.comparisonMode,
  QueryParamNames.comparisonSliderPosition,
] as const satisfies readonly QueryParamNames[];

export const EXIT_COMPARISON_QUERY: QueryType = Object.fromEntries(
  COMPARISON_QUERY_PARAM_NAMES.map((param) => [param, null]),
);
